function prettyPrintNumber(aNumber) {
  return Number(aNumber)
    .toFixed(2)
    .toLocaleString("en");
}

const helpers = {
  prettyPrintNumber
}

export default helpers


// WEBPACK FOOTER //
// ./src/helpers.js